import styled, { css } from 'styled-components';

export const Atributos = styled.section`
  margin-bottom: 90px;
  h3 {
    margin-bottom: calc(30px / 2);
    text-align: center;
  }
  div > p {
    margin: 0 auto;
    margin-bottom: calc(30px * 2);
    max-width: 625px;
    text-align: center;
  }
  .content {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    margin: -25px;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            margin: 0px;
          }
        `
      );
    }}
    .atributo {
      width: 33.33%;
      text-align: center;
      padding: 30px;
      margin-bottom: 30px;
      box-sizing: border-box;
      ${({ theme }) => {
        return (
          theme &&
          css`
            @media (max-width: ${theme.breakpoints.medium}) {
              width: 100%;
              padding: calc(30px / 2) 0;
            }
          `
        );
      }}
      .icon {
        width: 67px;
        height: 67px;
        margin: auto;
        margin-bottom: calc(30px / 2);
      }
      h5 {
        margin-bottom: calc(30px / 2);
      }
      p {
        max-width: 425px;
      }
    }
  }
  .btn {
    @extend .btn;
    display: block;
    line-height: 1.75em;
    margin: 0 auto;
    margin-top: 30px;
    width: max-content;
    ${({ theme }) => {
      return (
        theme &&
        css`
          @media (max-width: ${theme.breakpoints.medium}) {
            margin-top: calc(30px / 2);
          }
        `
      );
    }}
  }
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1440px;
  padding: 0 80px;
  ${({ theme }) => {
    return (
      theme &&
      css`
        @media (max-width: ${theme.breakpoints.medium}) {
          padding: 0 16px;
          flex-direction: column;
        }
      `
    );
  }}
`;
